import { api } from "../client";
import {
  DiscountCodeExtraFields,
  DiscountCodeFields,
  PartialDiscountCodeExtraFields,
  PartialDiscountCodeFields,
} from "../schema/DiscountCode";
import { Config, ConfigMutate } from "../types";

type ApiRequestConfig = Config<DiscountCodeFields, DiscountCodeExtraFields>;
type ApiRequestConfigMutate = ConfigMutate<
  PartialDiscountCodeFields,
  PartialDiscountCodeExtraFields
>;

export const getDiscountCodes = async (config?: ApiRequestConfig) => {
  return api.get<DiscountCodeFields, DiscountCodeExtraFields>(
    "discount_codes",
    config
  );
};
export const getDiscountCode = (id: number, config?: ApiRequestConfig) => {
  return api.get<DiscountCodeFields, DiscountCodeExtraFields>(
    `discount_codes/${id}`,
    config
  );
};

export const createDiscountCode = (config: ApiRequestConfigMutate) => {
  return api.create<PartialDiscountCodeFields, PartialDiscountCodeExtraFields>(
    "discount_codes",
    config
  );
};
export const updateDiscountCode = (
  id: number,
  config?: ApiRequestConfigMutate
) => {
  return api.update<PartialDiscountCodeFields, PartialDiscountCodeExtraFields>(
    `discount_codes/${id}`,
    config
  );
};
export const deleteDiscountCode = (id: number) => {
  return api.remove<DiscountCodeFields, DiscountCodeExtraFields>(
    `discount_codes/${id}`
  );
};
